(function(){
  // Accordion FAQ toggle
  document.querySelectorAll('.faq-btn').forEach(btn => {
    btn.addEventListener('click', function(){
      const item = this.parentElement;
      item.classList.toggle('open');
    });
  });
  
  // Sticky nav and scroll spy
  const nav = document.getElementById('helpNav');
  if(!nav) return;
  
  const links = nav.querySelectorAll('.help-nav-link');
  const sections = Array.from(document.querySelectorAll('#faqs, #envios, #contacto'));
  
  const spacer = document.createElement('div');
  spacer.className = 'help-nav-spacer';
  spacer.style.cssText = 'height:0;display:none';
  nav.parentNode.insertBefore(spacer, nav);
  
  let navOffsetTop = 0, navHeight = 0;
  let isMobile = window.innerWidth < 760;
  
  function measure(){
    isMobile = window.innerWidth < 760;
    const wasStuck = nav.classList.contains('stuck');
    nav.classList.remove('stuck');
    spacer.style.display = 'none';
    navOffsetTop = nav.getBoundingClientRect().top + window.pageYOffset;
    navHeight = nav.offsetHeight;
    if(wasStuck){
      nav.classList.add('stuck');
      spacer.style.cssText = 'display:block;height:' + navHeight + 'px';
    }
  }

  measure();
  window.addEventListener('resize', measure);
  
  links.forEach(link => {
    link.addEventListener('click', function(e){
      e.preventDefault();
      const target = this.dataset.target;
      const el = document.getElementById(target);
      if(el){
        const offset = isMobile ? 80 : (120 + navHeight + 20);
        const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({top: top, behavior: 'smooth'});
      }
    });
  });
  
  function updateNav(){
    const scrollY = window.scrollY;
    if(isMobile){
      const hero = document.querySelector('.plp-hero');
      const heroBottom = hero ? hero.offsetTop + hero.offsetHeight : 400;
      if(scrollY > heroBottom - 100){
        if(!nav.classList.contains('stuck')){
          nav.classList.add('stuck');
          spacer.style.cssText = 'display:block;height:' + navHeight + 'px';
        }
      } else if(nav.classList.contains('stuck')){
        nav.classList.remove('stuck');
        spacer.style.cssText = 'display:none;height:0';
      }
    } else {
      const threshold = navOffsetTop - 120;
      if(scrollY > threshold){
        if(!nav.classList.contains('stuck')){
          nav.classList.add('stuck');
          spacer.style.cssText = 'display:block;height:' + navHeight + 'px';
        }
      } else if(nav.classList.contains('stuck')){
        nav.classList.remove('stuck');
        spacer.style.cssText = 'display:none;height:0';
      }
    }
    
    const firstSection = sections[0];
    if(firstSection){
      const firstTop = firstSection.getBoundingClientRect().top + window.pageYOffset;
      if(scrollY < firstTop - 200){
        links.forEach(l => l.classList.remove('active'));
        return;
      }
    }
    let currentSection = null;
    for(const sec of sections){
      const rect = sec.getBoundingClientRect();
      if(rect.top <= 250 && rect.bottom > 250){
        currentSection = sec;
        break;
      }
    }
    if(currentSection){
      const id = currentSection.id;
      links.forEach(l => l.classList.toggle('active', l.dataset.target === id));
    }
  }
  
  let ticking = false;
  function onScroll(){
    if(!ticking){
      window.requestAnimationFrame(() => { updateNav(); ticking = false; });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  setTimeout(() => { measure(); updateNav(); }, 100);
})();
